// extracted by mini-css-extract-plugin
export default {"box":"ReasonDialog_box__fXuAO","count":"ReasonDialog_count__oTL3L"};